/* Traduzir textos do formulário de prescrição */

(function() {
  'use strict';

  function translateTexts() {
    const orElement = document.querySelector('.prescription_wrapper_title span');
    if (orElement && orElement.textContent.trim() === 'OR') {
      orElement.textContent = 'OU';
    }

    const fileNameElement = document.querySelector('.upload_file_name');
    if (fileNameElement && fileNameElement.textContent.trim() === 'No file chosen') {
      fileNameElement.textContent = 'Nenhum arquivo selecionado';
    }
  }

  function init() {
    translateTexts();

    // Observar mudanças no DOM para retraduir quando o app de prescrição injetar conteúdo.
    // Desconectar quando ambos os elementos estiverem traduzidos (ou após 8s como fallback).
    var observer = new MutationObserver(function() {
      translateTexts();
      var orEl = document.querySelector('.prescription_wrapper_title span');
      var fileEl = document.querySelector('.upload_file_name');
      if (orEl && orEl.textContent.trim() !== 'OR' &&
          fileEl && fileEl.textContent.trim() !== 'No file chosen') {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
